import type { ScheduleState } from "../../types/ScheduleState";

export const initalState: ScheduleState = {
    events: [],
    resources: [],
    allResources: [],
    loading: false,
    totalItems: 0,
    unassignedEvents: [],
    loadingUnassignedEvents: false,
    dispatch: () => null,
    dragAndDropCopy: false,
    type: "team",
    selectedCellOrEvent: undefined,
    columns: [],
    dailyInfo: false,
    weeklySummary: false,
    showCurrentTime: true,
    selectedEvents: [],
    selectedUnassignedEvents: [],
    ctrlShiftS: false,
    listView: undefined,
    refetch: false,
    count: 0,
    showTimeline: true,
    resetCount: () => Promise.resolve({ data: null } as any),
    showUnassigendShifts: false,
    clearSelectedEvents: () => null,
    openShifts: [],
    calendarEvents: {},
    moreModalEvents: [],
    loadingMoreModalEvents: false,
    moreModalTotalItems: 0,
    loadingOpenShifts: true,
    template: undefined,
    viewBy: "name",
    unavailable: [],
    templates: [],
    loadingTemplates: true,
    refetchEventStatistics: () => Promise.resolve({ data: null } as any),
}
